import { styled } from "styled-components";

export const AppHeaderMobileNavWrapper = styled.div`
  padding: 18rem 20rem;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  .logo {
    width: 63rem;
    height: 34rem;
    flex-shrink: 0;
    color: white;
  }

  .menu {
    width: 30rem;
    height: 30rem;
  }
`;
